import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { FormGroupDirective } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AzureFileUploadControl } from 'src/app/_controls/image-uploader';
import { ConferenceSpeakerExpenseViewModel } from 'src/app/_models/generatedModels';
import { ConferenceExpenseTrackingService } from 'src/app/_services/generatedServices';
import { ToasterService } from 'src/app/_services/toaster.service';
@Component({
  selector: 'bxl-edit-my-expense-modal',
  templateUrl: 'edit-my-expense-modal.component.html',
})
export class EditMyExpenseModalComponent implements OnInit {
  initialized = false;

  @Input() conferenceId: number;
  @Input() userId: number;
  @Input() expense: ConferenceSpeakerExpenseViewModel;

  model: ConferenceSpeakerExpenseViewModel;
  @ViewChild('myForm') myForm: FormGroupDirective;
  @ViewChild('receiptImage') receiptImage: AzureFileUploadControl;

  submitComplete: Promise<{}> | undefined;
  errorMessage: any;

  constructor(private activeModal: NgbActiveModal, private expenseService: ConferenceExpenseTrackingService, private toaster: ToasterService) {}

  ngOnInit(): void {
    this.model = new ConferenceSpeakerExpenseViewModel();

    if (this.expense) {
      Object.assign(this.model, this.expense);
      this.model.date = new Date(this.model.date);
    } else {
      this.model = new ConferenceSpeakerExpenseViewModel();
    }
    this.initialized = true;
  }

  onSave() {
    this.myForm.form.markAllControlsDirty();

    if (!this.myForm.valid) {
      this.toaster.error('Please fill out all required fields', 'Error');
      return;
    }

    this.submitComplete = new Promise((resetButton: any, reject) => {
      this.receiptImage.Upload().then((result) => {
        this.model.fileName = result.filename;
        this.model.fileType = result.mimeType;

        if (this.expense) {
          this.updateExpense(resetButton);
        } else {
          this.addExpense(resetButton);
        }
      });
    });
  }



  addExpense(resetButton: any) {
    this.expenseService.addPersonalExpense(this.conferenceId, this.model).subscribe(
      (result) => {
        this.toaster.success('Expense Added', 'Success');
        this.activeModal.close();
        resetButton();
      },
      (error) => {
        this.toaster.error('Error adding expense', 'Error');
        this.errorMessage = error.error[0];
        resetButton();
      }
    );
  }

  updateExpense(resetButton: any) {
    this.expenseService.updatePersonalExpense(this.conferenceId, this.expense.id, this.model).subscribe(
      (result) => {
        this.toaster.success('Expense Updated', 'Success');
        this.activeModal.close();
        resetButton();
      },
      (error) => {
        this.toaster.error('Error updating expense', 'Error');
        this.errorMessage = error.error[0];
        resetButton();
      }
    );
  }

  onCancel() {
    this.activeModal.dismiss();
  }
}
